import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ReviewItem from 'app/components/review/ReviewItem';
import { Paginate, Spinner } from 'app/seedly-component-library';
import { REVIEW_PAGE_TYPE } from 'app/constants/product';
import { Frown } from 'react-feather';

import {
  getUserReviewsNextPage,
  getProductReviewsNextPage,
} from 'app/dispatcher/reviewDispatcher';

const ReviewList = props => {
  const dispatch = useDispatch();

  const {
    onPageChange,
    type,
    profileSlug,
    product,
    itemContainerStyles,
    customEmpty,
  } = props;

  const reviewIds = useSelector(state => state.review.meta.ids);
  const reviewById = useSelector(state => state.review.byId);
  const filterTag = useSelector(state => state.review.meta.filterTag);
  const filterText = useSelector(state => state.review.meta.filterText);
  const pagination = useSelector(state => state.review.meta.pagination);
  const sortType = useSelector(state => state.review.meta.sortType);
  const isFetchingReviews = useSelector(state => state.review.api.isFetching);

  const { currentPage, totalPage } = pagination;

  const handleLoadMoreReviews = data => {
    onPageChange();
    const page = data.selected + 1;
    switch (type) {
      case REVIEW_PAGE_TYPE.PROFILE:
        return dispatch(getUserReviewsNextPage({ profileSlug, page }));
      default:
      case REVIEW_PAGE_TYPE.PRODUCT:
        return dispatch(
          getProductReviewsNextPage(
            { productId: product.id, page, tag: filterTag },
            { sortType, tag: filterTag, filterText },
          ),
        );
    }
  };

  if (isFetchingReviews) {
    return <Spinner />;
  }

  if (reviewIds.length === 0) {
    if (customEmpty) return customEmpty;
    if (filterTag) {
      return (
        <div className="flex items-center justify-center w-full pt-8 flex-col">
          <Frown className="text-neutral-700 opacity-20 mb-4" />
          <div
            className="w-[200px] text-center text-neutral-500 font-bold text-xs"
            data-testid="search-not-found-text"
          >
            No reviews found, try searching something else?
          </div>
        </div>
      );
    }
    return (
      <div className="flex items-center justify-center w-full h-[108px] bg-white rounded">
        <p className="text-center text-neutral-500">No reviews found.</p>
      </div>
    );
  }

  return (
    <ul data-testid="review-list">
      {reviewIds.map(reviewId => {
        return (
          <li className="mb-2 w-full lg:w-auto" key={reviewId}>
            <ReviewItem
              containerStyles={itemContainerStyles}
              review={reviewById[reviewId]}
              type={type}
            />
          </li>
        );
      })}
      <div className="h-[70px] w-full flex items-center justify-center">
        <Paginate
          pageCount={totalPage}
          forcePage={currentPage - 1}
          onPageChange={handleLoadMoreReviews}
        />
      </div>
    </ul>
  );
};

export default ReviewList;
